import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';

/**
 * (5) Fuera el selector de idioma — la comunidad es solo en español (T10).
 *
 * El desplegable «Español / English» lo pinta el CORE, no una extension: `HeaderSecondary.js`
 * lo agrega con la clave `locale` cuando hay mas de un locale instalado y el ajuste
 * `show_language_selector` esta activo. En produccion hay dos locales instalados
 * (`flarum-lang/spanish` + el `en` de fabrica), asi que aparecia.
 *
 * POR QUE EN CODIGO Y NO SOLO EN EL AJUSTE. `show_language_selector=0` lo apaga igual, y el
 * deploy de T10 lo pone (asi el HTML servido no lo trae ni un instante). Pero un ajuste vive
 * en la base de datos y se puede volver a encender desde el panel sin que nadie lo note; esta
 * regla es la que hace que la decision de producto viaje con el repo. Las dos apuntan al
 * mismo item y no se estorban: quitar algo que ya no esta es un no-op.
 *
 * `items.remove()` de la ItemList del core no revienta si la clave no existe — no hace falta
 * un `has()` de guarda.
 */
export default function hideLocaleSwitcher() {
  extend(HeaderSecondary.prototype, 'items', function (items: any) {
    items.remove('locale');
  });
}
